export class Check {
    id!: string;
    name!: string;
    target!: string;
    type!: string;
    metadata!: string;

    last_result!: any;
}
